import React, { Component } from 'react'
import { graphql } from 'gatsby'
import Img from 'gatsby-image'
import SEO from '../../../components/seo'

import axios from 'axios'

import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Table from 'react-bootstrap/Table'

import Layout from '../../../components/layout/layout'
import NextPreviousRow from '../../../components/next-previous'
import PageTitle from '../../../components/page-title'

import isUserSignedIn from '../../../auth/is-user-signed-in'

import StudentContent from '../../../components/layout/student-content'
import TeacherContentStudentAccordion from '../../../components/layout/teacher-content/teacher-content-student-accordion'
import TeacherContentTeacherAccordion from '../../../components/layout/teacher-content/teacher-content-teacher-accordion'
import Video from '../../../components/video'

// eslint-disable-next-line
import threedmssImage from '../../../queries/threedmssImage'

const Page = class extends Component {
  constructor(props) {
    super(props)

    this.state = {
      student_accordion_open: true,
      authenticated: undefined
    }

    this.axios_cancel_token = axios.CancelToken.source()
  }

  async componentDidMount() {
    const is_signed_in = isUserSignedIn()
    this.setState({ authenticated: is_signed_in })
  }

  render() {
    const { location } = this.props
    if (this.state.authenticated === undefined) {
      return (
        <React.Fragment>
          <Layout>
            <Container fluid className="d-flex h-100 flex-column pt-3">
              <Row className="mb-3 justify-content-center w-100">
                <div className="spinner-grow text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </Row>
            </Container>
          </Layout>
        </React.Fragment>
      )
    } else {
      return (
        <React.Fragment>
          <SEO title="Evidence #4: Small Intestine Micrographs" />
          <Layout
            location={location}
            course="threedmss"
            setStudentAccordionState={(state) => this.setState({ student_accordion_open: state })}
            setAuthenticated={(is_signed_in) => this.setState({ authenticated: is_signed_in })}
          >
            <Container fluid className="d-flex h-100 flex-column pt-3">
              <PageTitle title="Evidence #4: Small Intestine Micrographs" no_breadcrumb={true} />
              <Row style={{ marginBottom: '2rem' }}>
                {this.state.authenticated &&
                  <React.Fragment>
                    <Col xs={12} lg={6} id="student-accordion-column">
                      <TeacherContentStudentAccordion
                        title="Student View"
                        open={this.state.student_accordion_open}
                        setStudentAccordionState={() => {
                          /*
                            Anytime this is called, it's toggling so I'm just setting it to the opposite of its current state. This is to sync the student accordion state with the ToggleStudentView component.  Pretty much just don't worry about it. Keep walking.
                          */
                          if (this.state.student_accordion_open) {
                            this.setState({ student_accordion_open: false })
                          } else {
                            this.setState({ student_accordion_open: true })
                          }
                        }}
                      >
                        <div className="row">
                          <div className="col-12">
                            <hr className="focus-question-heading bold-me d-none d-md-block d-lg-none d-xl-block" />
                            <h3 className="bold-me d-block d-md-none d-lg-block d-xl-none text-center">Focus Question</h3>
                            <hr className="d-block d-md-none d-lg-block d-xl-none" />
                            <p className="focus-question bold-me">How does food move from the small intestine to the rest of the body, and what is different about M'Kenna's intestine?</p>
                            <hr className="after-focus-question" />
                          </div>
                        </div>

                        <div className="row">


                          <div className="col-12">
                          <div className="image-wrapper">
                            <Img
                              fluid={this.props.data.image1.childImageSharp.fluid}
                              alt="Micrograph images of small intestines"
                              className="image"
                            />
                            <div className="image-caption">
                              A micrograph is a photo taken through a microscope. One of these images is a micrograph of healthy small intestine and the other is a micrograph of M'Kenna's small intestine. Can you determine which one is M'Kenna's? <br />
                              <span className="image-credit">Courtesy David Litman/Shutterstock.com, Biophoto Associates/Science Photo Library</span>
                            </div>
                          </div>
                            <p>When M'Kenna visited her doctor for the endoscopy exam, the doctor decided to take a sample of tissue to examine under a microscope. The sample of tissue was very small. The doctor took the sample to the lab and looked at it through a microscope.</p>

                            <p>The doctor then made a photograph of the sample to show M'Kenna and her family. A photograph taken by a microscope is called a micrograph. In this activity, you will examine two micrographs and make observations of the tissue in both pictures. You may even be able to identify cells in the tissue you see. You will decide which tissue you believe is M'Kenna's and why you think the tissue is not doing a good job absorbing nutrients.</p>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-12">
                            <hr className="collaborate-icon my-5" />
                            <span className="sr-only">Collaboration Icon</span>
                            <h3 className="section-heading bold-me my-4">Work with your team to make observations of micrographs.</h3>

                            <p className="list-heading bold-me underline-me">With your team</p>
                            <ol>
                              <li>Make observations of the two micrographs. Use the <a href="https://media.bscs.org/3dmss/se/documents/02_vil/observations_of_intestinal_tissue_handout.pdf" target="_blank" rel="noopener noreferrer"><span className="italic">Observations of Intestinal Tissue</span>&nbsp;<sup><i  style={{fontSize: '.65rem'}}  className="fas fa-external-link-alt"></i></sup></a> handout to record your observations.</li>
                              <li>Make a claim about which tissue belongs to M'Kenna and use evidence from your observations to support your claim.</li>
                              <li>Be prepared to share what you observed and your claim when prompted by your teacher.</li>
                            </ol>

                            <p className="list-heading bold-me underline-me">On your own</p>
                            <ol start="4">
                              <li>Attach <span className="italic">Observations of Intestinal Tissue</span> to your science notebook. Title the page, "Evidence #4: Small Intestine Micrographs."</li>
                            </ol>
                          </div>
                        </div>
                      </TeacherContentStudentAccordion>
                    </Col>
                    <Col xs={12} lg={6} name="teacher-accordion-column">
                      <Container fluid>
                        <Row>
                          <TeacherContentTeacherAccordion title="Time Estimate" open={true}>
                            <p>Estimated time to complete this web page: 15 min</p>
                          </TeacherContentTeacherAccordion>

                          <TeacherContentTeacherAccordion title="Before You Teach">
                            <p>Make copies of the <a href="https://media.bscs.org/3dmss/se/documents/02_vil/observations_of_intestinal_tissue_handout.pdf" target="_blank" rel="noopener noreferrer" className="italic">Observations of Intestinal Tissue&nbsp;<sup><i  style={{fontSize: '.65rem'}}  className="fas fa-external-link-alt"></i></sup></a> handout, if you haven't already.</p>
                          </TeacherContentTeacherAccordion>

                          <TeacherContentTeacherAccordion title="Where are we in the storyline?">
                            <p className="bold-me">Storyline for Disciplinary Core Ideas (DCIs)</p>

                            <p>In chapter 1, students figured out that there is something wrong with M'Kenna's small intestine. In the bridge between chapters 1 and 2, they figured out that tissue (including small intestine tissue) is made of cells, and those cells have parts called a nucleus and a cell membrane. Armed with this information, students can start looking more closely at M'Kenna's small intestine and comparing it to a healthy small intestine. At a microscopic level, what's wrong with M'Kenna's small intestine? Students share their initial ideas in this Engage activity. It's OK if they don't have all the answers figured out yet, they should by the <span className="italic">end</span> of the chapter.</p>

                            <p className="bold-me">Storyline for Science and Engineering Practices (SEPs)</p>

                            <p>Students use their existing understanding to create a model to show how our bodies get nutrients from the food we eat. How does it get from inside our small intestine to everywhere else?</p>

                            <p>Students note where they think their models might not be doing a good job of helping them explain how food passes from inside the small intestine to the rest of the body (they identify existing model limitations). For example, students with a "hollow tube" model of the digestive system might not understand how nutrients get to the rest of the body.</p>

                            <p className="bold-me">Storyline for Crosscutting Concepts (CCCs)</p>

                            <p>In the Engage section, students begin to consider the structure of M'Kenna's small intestine as a possible cause of M'Kenna's symptoms (effect). They will gather more information before they can have confidence in the cause/effect relationship.</p>
                          </TeacherContentTeacherAccordion>

                          <TeacherContentTeacherAccordion title="Phenomenon for This Lesson">
                            <p>Nutrients from food are absorbed into the bloodstream from the small intestine.</p>
                          </TeacherContentTeacherAccordion>

                          <TeacherContentTeacherAccordion title="Main Learning Goal" open={true}>
                            <p>The learning goal stated here is actually the <span className="bold-me">chapter level</span> goal. <span className="italic">Students won't achieve this learning goal until the end of the chapter.</span></p>

                            <p>Small intestine tissue is made of specialized cells with structures that facilitate nutrient absorption into the bloodstream. Factors such as the surface area of cell membranes and food particle size affect absorption. M'Kenna's small intestine has flattened villi causing reduced surface area for absorption.</p>
                          </TeacherContentTeacherAccordion>

                          <TeacherContentTeacherAccordion title="Teacher Moves During Lesson: Step 1" open={true}>
                            <ol type="A">
                              <li>Distribute the handout <a href="https://media.bscs.org/3dmss/se/documents/02_vil/observations_of_intestinal_tissue_handout.pdf" target="_blank" rel="noopener noreferrer"><span className="italic">Observations of Intestinal Tissue</span>&nbsp;<sup><i  style={{fontSize: '.65rem'}}  className="fas fa-external-link-alt"></i></sup></a>.</li>
                              <li>In <span className="bold-me">step 1</span>, students work in teams to make observations of the micrographs. If you right-click on the image (on a PC), you can select "view image." Or on a Mac, right-click the image and select "Open Image in New Tab." Show students that the inside of the small intestine is above each pink image, and the outside of the small intestine is below each pink image. This will open a big view of the micrographs that you can project for the class. Ask students to look carefully at the images. Can they see cell membranes and nuclei? If they look very closely, they can see that the image they are looking at is actually intestinal tissue that is made of many cells. This is easiest to see in the bottom picture. Make sure students connect the patterns they see in the two images of intestinal tissue to the patterns they saw in the Chapter 1-2 bridge.</li>
                            </ol>
                          </TeacherContentTeacherAccordion>

                          <TeacherContentTeacherAccordion title="Teacher Moves During Lesson: Step 2, Discussion">
                            <ol type="A" start={3}>
                              <li>In <span className="bold-me">step 2</span>, students work as a team to use the ideas they have gained thus far to make a claim about which micrograph image is M'Kenna's. They should support their claim with evidence and reasoning. If members of a team disagree, that is OK. Just make sure each claim is supported with evidence and reasoning. You might need to prompt students to be more specific.</li>
                            </ol>

                            <Table responsive className="bscs-table">
                              <thead>
                                <tr>
                                  <th className="p-2" scope="col">
                                    <span className="sr-only">Suggested Prompts</span>
                                    <p className="bold-me">Suggested Prompts</p>
                                  </th>
                                  <th className="p-2" style={{ width: '33%' }} scope="col">
                                    <span className="sr-only">Possible Student Responses</span>
                                    <p className="bold-me"><span className="italic">Possible Student Responses</span></p>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className="p-2"><p>I see here that you said "It looks like the bumpy one is like the healthy pictures we saw before." Which pictures do you mean?</p></td>
                                  <td className="p-2"><p><span className="italic">I mean those pictures we saw at the end of the last chapter with the endoscope. In those pictures, the healthy intestine had lots of ridges and M'Kenna's intestine looked smooth.</span></p></td>
                                </tr>
                                <tr>
                                  <td className="p-2"><p>OK, be sure to be specific that you mean the endoscope pictures here. Also, is there a difference in scale between the endoscope pictures and these pictures?</p></td>
                                  <td className="p-2"><p><span className="italic">Oh, yeah. The endoscope was just like a regular photograph. But these had to be with a microscope.</span></p></td>
                                </tr>
                              </tbody>
                            </Table>
                          </TeacherContentTeacherAccordion>

                          <TeacherContentTeacherAccordion title="Teacher Moves During Lesson: Step 3, Discussion">
                            <ol type="A" start={4}>
                              <li>In <span className="bold-me">step 3</span>, ask at least one student from each group to share their claim, evidence, and reasoning.</li>
                              <li>Note that at the end of this Engage activity, students do NOT yet revise their answer to the focus question. In this case, they won't revise their answer to this particular focus question until the end of the chapter.</li>
                            </ol>

                            <Table responsive className="bscs-table">
                              <thead>
                                <tr>
                                  <th className="p-2" scope="col">
                                    <span className="sr-only">Suggested Prompts</span>
                                    <p className="bold-me">Suggested Prompts</p>
                                  </th>
                                  <th className="p-2" style={{ width: '33%' }} scope="col">
                                    <span className="sr-only">Possible Student Responses</span>
                                    <p className="bold-me"><span className="italic">Possible Student Responses</span></p>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className="p-2"><p>Who would like to make a claim about which tissue belongs to M'Kenna and use evidence to support their claim?</p></td>
                                  <td className="p-2"><p><span className="italic">We think the bumpy one is M'Kenna's. It just looks really squiggly, like it's torn or something. M'Kenna had diarrhea and maybe a torn intestine is what is giving her diarrhea.</span></p></td>
                                </tr>
                                <tr>
                                  <td className="p-2"><p>Anyone agree or disagree?</p></td>
                                  <td className="p-2"><p><span className="italic">We disagree, we thought the smooth one was M'Kenna's because the smooth picture reminded us of M'Kenna's endoscopy picture.</span></p></td>
                                </tr>
                              </tbody>
                            </Table>
                          </TeacherContentTeacherAccordion>

                          <TeacherContentTeacherAccordion title="Classroom Video from This Lesson" open={true}>
                            <hr style={{ margin: '10px 0' }} />
                            <div className="text-center">
                              {/* For multiple icons: Every icon except the last one should have margin-right: 1rem; */}
                              {/* For a single icon, leave margin-right: 1rem; out all together. */}
                              <img src="https://media.bscs.org/3dmss/te/icons/video-ant-icon.svg" alt="Video Ant icon." style={{ width: '42px', marginRight: '1rem' }} />
                            </div>

                            <hr style={{ margin: '10px 0' }} />
                            <div className="col-12">
                              <span className="sr-only">Video Ant Icon</span>
                            </div>

                            <p><span className="bold-me">Video Summary</span></p>

                            <p>Students are discussing their claims about which micrograph is the healthy sample and which on is M'Kenna's. They have just examined Evidence #4 at the end of the Engage in Chapter 2 and are making their claims and supporting their claims with evidence and reasoning</p>

                            <Video vimeo_id="311939778" />

                            <p><a href="https://media.bscs.org/3dmss/te/documents/02_vil/3dmss_pdvid_ch2_8_exarg_transcript.pdf" target="_blank" rel="noopener noreferrer">Transcript&nbsp;<sup><i  style={{fontSize: '.65rem'}}  className="fas fa-external-link-alt"></i></sup></a></p>
                          </TeacherContentTeacherAccordion>
                        </Row>
                      </Container>
                    </Col>
                  </React.Fragment>
                }
                {!this.state.authenticated &&
                  <StudentContent>
                    <div className="row">
                      <div className="col-12">
                        <hr className="focus-question-heading bold-me" />
                        <p className="focus-question bold-me">How does food move from the small intestine to the rest of the body, and what is different about M'Kenna's intestine?</p>
                        <hr className="after-focus-question" />
                      </div>
                    </div>

                    <div className="row">


                      <div className="col-12">
                      <div className="image-wrapper-left">
                        <Img
                          fluid={this.props.data.image1.childImageSharp.fluid}
                          alt="Micrograph images of small intestines"
                          className="image"
                        />
                        <div className="image-caption">
                          A micrograph is a photo taken through a microscope. One of these images is a micrograph of healthy small intestine and the other is a micrograph of M'Kenna's small intestine. Can you determine which one is M'Kenna's?<br />
                          <span className="image-credit">Courtesy David Litman/Shutterstock.com, Biophoto Associates/Science Photo Library</span>
                        </div>
                      </div>
                        <p>When M'Kenna visited her doctor for the endoscopy exam, the doctor decided to take a sample of tissue to examine under a microscope. The sample of tissue was very small. The doctor took the sample to the lab and looked at it through a microscope.</p>

                        <p>The doctor then made a photograph of the sample to show M'Kenna and her family. A photograph taken by a microscope is called a micrograph. In this activity, you will examine two micrographs and make observations of the tissue in both pictures. You may even be able to identify cells in the tissue you see. You will decide which tissue you believe is M'Kenna's and why you think the tissue is not doing a good job absorbing nutrients.</p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <hr className="collaborate-icon my-5" />
                        <span className="sr-only">Collaboration Icon</span>
                        <h3 className="section-heading bold-me my-4">Work with your team to make observations of micrographs.</h3>

                        <p className="list-heading bold-me underline-me">With your team</p>
                        <ol>
                          <li>Make observations of the two micrographs. Use the <a href="https://media.bscs.org/3dmss/se/documents/02_vil/observations_of_intestinal_tissue_handout.pdf" target="_blank" rel="noopener noreferrer"><span className="italic">Observations of Intestinal Tissue</span>&nbsp;<sup><i  style={{fontSize: '.65rem'}}  className="fas fa-external-link-alt"></i></sup></a> handout to record your observations.</li>
                          <li>Make a claim about which tissue belongs to M'Kenna and use evidence from your observations to support your claim.</li>
                          <li>Be prepared to share what you observed and your claim when prompted by your teacher.</li>
                        </ol>

                        <p className="list-heading bold-me underline-me">On your own</p>
                        <ol start="4">
                          <li>Attach <span className="italic">Observations of Intestinal Tissue</span> to your science notebook. Title the page, "Evidence #4: Small Intestine Micrographs."</li>
                        </ol>
                      </div>
                    </div>
                  </StudentContent>
                }
              </Row>
              <NextPreviousRow location={location} authenticated={this.state.authenticated} />
            </Container>
          </Layout>
        </React.Fragment>
      )
    }
  }
}

export default Page

export const query = graphql`
  query {
    image1: file(relativePath: { eq: "02_vil/1463_1473.jpg" }) {
      ...threedmssImage
    }
  }
`
